import Button from "@material-ui/core/Button";
import DialogContentText from "@material-ui/core/DialogContentText";
import { useBrandQuery } from "@saleor/collections/queries";
import ActionDialog from "@saleor/components/ActionDialog";
// import AssignCategoriesDialog from "@saleor/components/AssignCategoryDialog";
// import AssignCollectionDialog from "@saleor/components/AssignCollectionDialog";
import AssignDiscountSaleProductDialog from "@saleor/components/AssignDiscountSaleProductDialog";
import AssignStoresDialog from "@saleor/components/AssignStoreDialog";
import { WindowTitle } from "@saleor/components/WindowTitle";
import { DEFAULT_INITIAL_SEARCH_DATA, PAGINATE_BY } from "@saleor/config";
import useBulkActions from "@saleor/hooks/useBulkActions";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import usePaginator, {
  createPaginationState
} from "@saleor/hooks/usePaginator";
import useShop from "@saleor/hooks/useShop";
import useUser from "@saleor/hooks/useUser";
// import useUser from "@saleor/hooks/useUser";
import { sectionNames } from "@saleor/intl";
import useBrandUpdate from "@saleor/products/hooks/useBrandUpdate";
import {
  SearchProductTypes_search_edges,
  SearchProductTypesVariables
} from "@saleor/searches/types/SearchProductTypes";
import useBrandPrivateSearch from "@saleor/searches/useBrandPrivateSearch";
import useCategorySearch from "@saleor/searches/useCategorySearch";
// import useCollectionSearch from "@saleor/searches/useCollectionSearch";
import useProductSearch from "@saleor/searches/useProductSearch";
import useProductTypeSearch from "@saleor/searches/useProductTypeSearch";
import useStoreSearch from "@saleor/searches/useStoreSearch";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import { changeTimeZone } from "@saleor/utils/smop/changeTimeZoneDateTime";
import React, { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";

// import { categoryUrl } from "../../categories/urls";
// import { collectionUrl } from "../../collections/urls";
import { decimal, maybe } from "../../misc";
import { productUrl } from "../../products/urls";
import {
  DiscountStatusEnum,
  DiscountValueTypeEnum,
  FileTypesEnum,
  OrderDirection,
  ProductStatusEnum,
  ProductUserViewEnum,
  SaleType,
  SmopStatusEnum,
  StoreTypeEnum,
  TenantSortField
} from "../../types/globalTypes";
import AssignProductSubsidyDialog from "../components/AssignSalesProductSubsidyDialog";
import SaleDetailsPage, {
  SaleDetailsPageFormData,
  SaleDetailsPageTab
} from "../components/SaleDetailsPage";
import useSaleUserType, { SaleUser } from "../hooks/useSaleUserType";
import {
  TypedSaleCataloguesAdd,
  TypedSaleCataloguesRemove,
  TypedSaleUpdate,
  TypedUpdateSaleStatus,
  useSaleErrorVariants
} from "../mutations";
import {
  useExportSaleErrorVariantStatus,
  useSaleDetails,
  useSaleValidate,
  // useSaleProductDetails,
  // useSaleProductDetails,
  useSaleVariantDetails
} from "../queries";
import { SaleCataloguesAdd } from "../types/SaleCataloguesAdd";
import { SaleCataloguesRemove } from "../types/SaleCataloguesRemove";
import { SaleUpdate } from "../types/SaleUpdate";
import { UpdateSaleStatus } from "../types/UpdateSaleStatus";
import {
  saleListUrl,
  saleUrl,
  SaleUrlDialog,
  SaleUrlQueryParams
} from "../urls";
interface SaleDetailsProps {
  id: string;
  params: SaleUrlQueryParams;
}

function discountValueTypeEnum(type: SaleType): DiscountValueTypeEnum {
  switch (type.toString()) {
    case DiscountValueTypeEnum.FIXED:
      return DiscountValueTypeEnum.FIXED;
    case DiscountValueTypeEnum.PERCENTAGE:
      return DiscountValueTypeEnum.PERCENTAGE;
    case DiscountValueTypeEnum.ABSOLUTE_VALUE:
      return DiscountValueTypeEnum.ABSOLUTE_VALUE;
  }
}

function getUserAccessTypes(
  userType,
  saleUser: SaleUser,
  productTypeSearchResults: SearchProductTypes_search_edges[]
): StoreTypeEnum[] | [] {
  let userAccessTypes = [];

  if (!saleUser.isKAMS && !saleUser.isSuperUser) {
    userAccessTypes = userType.accesses.map(({ storeType }) => storeType);
  } else if (saleUser.isSuperUser) {
    userAccessTypes = [
      StoreTypeEnum.FOOD_AND_BEVERAGES,
      StoreTypeEnum.GENERAL_MERCHANDISE,
      StoreTypeEnum.GROCERY
    ];
  } else if (saleUser.isKAMS && productTypeSearchResults !== undefined) {
    userAccessTypes = productTypeSearchResults.map(edge => edge.node.storeType);
  } else {
    userAccessTypes = [];
  }

  return userAccessTypes;
}

function getProductTypeSearchVariables(
  saleUser: SaleUser,
  defaultSearchData: SearchProductTypesVariables,
  brand: string
) {
  let searchVariables = { ...defaultSearchData };

  if (saleUser.isKAMS) {
    searchVariables = {
      ...defaultSearchData,
      brand
    };
  }

  return searchVariables;
}

function getStoreTypeByUserAccess(
  saleUser: SaleUser,
  userAccessTypes: StoreTypeEnum[],
  productTypeSearchResults: SearchProductTypes_search_edges[]
): StoreTypeEnum {
  let storeType;

  if (!saleUser.isKAMS) {
    storeType = userAccessTypes.length > 0 && userAccessTypes[0];
  } else if (
    saleUser.isKAMS &&
    productTypeSearchResults !== undefined &&
    productTypeSearchResults.length
  ) {
    storeType = productTypeSearchResults[0].node.storeType;
  }

  return storeType;
}

export const SaleDetails: React.FC<SaleDetailsProps> = ({ id, params }) => {
  const navigate = useNavigator();
  const paginate = usePaginator();
  const notify = useNotifier();
  const shop = useShop();
  const {
    user: { userType }
  } = useUser();

  const { isSelected, listElements, reset, toggle, toggleAll } = useBulkActions(
    params.ids
  );
  const intl = useIntl();
  // const [_, setCurrentBrand] = React.useState(null);

  // const {
  //   loadMore: loadMoreCollections,
  //   search: searchCollections,
  //   result: searchCollectionsOpts
  // } = useCollectionSearch({
  //   variables: DEFAULT_INITIAL_SEARCH_DATA
  // });

  // const user = useUser();

  const [selectedCategory, setSelectedCategory] = React.useState(null);
  const [selectedBrand, setSelectedBrand] = React.useState(null);
  const [
    saleSubsidyErrorQuantity,
    setSaleSubsidyErrorQuantity
  ] = React.useState(null);
  const [saleErrorExportFileID, setSaleErrorExportFileID] = React.useState(
    null
  );
  const [saleErrorExportFileLink, setSaleErrorExportFileLink] = React.useState(
    null
  );

  // If KAMS, get product type of selected brand. Skip if not KAMS

  const saleUser = useSaleUserType();

  const { result: searchProductTypesOpts } = useProductTypeSearch({
    skip: !saleUser.isKAMS,
    variables: getProductTypeSearchVariables(
      saleUser,
      DEFAULT_INITIAL_SEARCH_DATA,
      params.brand
    )
  });

  const userAccessTypes: StoreTypeEnum[] = getUserAccessTypes(
    userType,
    saleUser,
    searchProductTypesOpts.data?.search.edges
  );

  const {
    loadMore: loadMoreCategories,
    search: searchCategories,
    result: searchCategoriesOpts
  } = useCategorySearch({
    variables: {
      ...DEFAULT_INITIAL_SEARCH_DATA,
      storeType: getStoreTypeByUserAccess(
        saleUser,
        userAccessTypes,
        searchProductTypesOpts.data?.search.edges
      )
    }
  });

  const categories = maybe(
    () => searchCategoriesOpts.data.search.edges,
    []
  ).map(edge => edge.node);

  const DEFAULT_INITIAL_SEARCH_STORE_DATA = {
    after: null,
    direction: OrderDirection.ASC,
    field: TenantSortField.NUMBER,
    first: 20,
    query: ""
  };

  const DEFAULT_INITIAL_SEARCH_PRODUCT_DATA = {
    after: null,
    categories: selectedCategory,
    first: 20,
    productStatus: ProductStatusEnum.READY,
    query: ""
  };
  const {
    loadMore: loadMoreProducts,
    search: searchProducts,
    result: searchProductsOpts
  } = useProductSearch({
    variables: {
      ...DEFAULT_INITIAL_SEARCH_PRODUCT_DATA,
      ...(saleUser.isKAMS && {
        userViewInfo: {
          brandId: params.brand,
          viewAs: ProductUserViewEnum.SELLER_MASTER
        }
      }),
      ...(selectedBrand && { brands: [selectedBrand] }),
      ...(selectedCategory && { categories: [selectedCategory] })
    }
  });
  const { result: searchStoresOpts, search: searchStore } = useStoreSearch({
    variables: DEFAULT_INITIAL_SEARCH_STORE_DATA
  });

  const { result: brandsResult } = useBrandPrivateSearch({
    skip: !saleUser.isKAMS,
    variables: {
      ...DEFAULT_INITIAL_SEARCH_DATA,
      accountManager: saleUser.id
    }
  });

  const brands = maybe(() => brandsResult?.data?.search?.edges, []).map(
    edge => edge.node
  );

  // Hook for updating of brands
  const [onBrandChange, brand, brandChoices] = useBrandUpdate(
    params,
    brands,
    brandsResult.loading
  );

  const paginationState = createPaginationState(PAGINATE_BY, params);
  const changeTab = (tab: SaleDetailsPageTab) => {
    reset();
    navigate(
      saleUrl(id, {
        activeTab: tab
      })
    );
  };

  const { data, loading, refetch } = useSaleDetails({
    displayLoader: true,
    variables: {
      first: PAGINATE_BY,
      id
    }
  });

  const brandInitialSearchData = {
    after: null,
    first: 20,
    query: "",
    status: SmopStatusEnum.ACT
  };

  const {
    loadMore: loadMoreBrand,
    search: searchBrands,
    result: brandsQueryData
  } = useBrandQuery({
    variables: {
      ...brandInitialSearchData
    }
  });

  const sellerBrandChoices = maybe(
    () => brandsQueryData?.data?.search?.edges,
    []
  ).map(edge => edge.node);

  // const { data: productData, refetch: refetchProduct } = useSaleProductDetails({
  //   displayLoader: true,
  //   skip: data && data.sale && data.sale.type === "ABSOLUTE_VALUE",
  //   variables: {
  //     id,
  //     ...paginationState
  //   }
  // });

  const { data: variantData, refetch: refetchVariant } = useSaleVariantDetails({
    displayLoader: true,
    // skip: data && data.sale && data.sale.type === "PERCENTAGE",
    variables: {
      id,
      ...(saleUser.isKAMS && { brand: params.brand }),
      ...paginationState
    }
  });

  const {
    data: errorVariantCount,
    refetch: refetchErrorVariantCount
  } = useSaleValidate({
    displayLoader: true,
    variables: {
      id
    }
  });

  const {
    data: exportSaleErrorStatus,
    refetch: refetchSaleErrorStatus
  } = useExportSaleErrorVariantStatus({
    displayLoader: true,
    skip: saleErrorExportFileID === null ? true : false,
    variables: {
      id: saleErrorExportFileID
    }
  });

  React.useEffect(() => {
    if (exportSaleErrorStatus) {
      if (exportSaleErrorStatus.exportFile.status === "PENDING") {
        refetchSaleErrorStatus();
      } else if (
        exportSaleErrorStatus.exportFile.status === "SUCCESS" &&
        exportSaleErrorStatus?.exportFile?.url
      ) {
        setSaleErrorExportFileLink(exportSaleErrorStatus?.exportFile?.url);
      } else if (exportSaleErrorStatus.exportFile.status === "FAILED") {
        notify({
          status: "error",
          text: "Something went wrong with the download link"
        });
      }
    }
  }, [exportSaleErrorStatus]);

  const [exportErrorVariants] = useSaleErrorVariants({
    onCompleted: data => {
      if (data.exportSaleErrorVariants.exportErrors.length === 0) {
        setSaleErrorExportFileID(data.exportSaleErrorVariants.exportFile.id);
      }
    }
  });

  const handleUpdateSaleStatus = (data: UpdateSaleStatus) => {
    if (data.updateSaleStatus.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Sales Deactivated."
        })
      });
      navigate(saleListUrl(), true);
    }
  };

  const handleSaleUpdate = (data: SaleUpdate) => {
    if (data.saleUpdate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Sales Updated."
        })
      });

      closeModal();
      refetch();
    } else if (
      data.saleUpdate.errors.some(e => e.code === "UNIQUE") &&
      data.saleUpdate.errors.some(e => e.field === "name")
    ) {
      notify({
        status: "error",
        text: intl.formatMessage({
          defaultMessage: "Discount name is already existing"
        })
      });
    } else if (
      data.saleUpdate.errors.some(e => e.code === "INVALID") &&
      errorVariantCount.saleValidate.errorVariantsCount > 0
    ) {
      setSaleSubsidyErrorQuantity(
        errorVariantCount.saleValidate.errorVariantsCount
      );
      exportErrorVariants({
        variables: {
          input: {
            fileName: "ProductErrorList",
            fileType: FileTypesEnum.CSV,
            saleId: id
          }
        }
      });
      notify({
        status: "error",
        text: data.saleUpdate.errors[0].message
      });
    } else {
      notify({
        status: "error",
        text: data.saleUpdate.errors[0].message
      });
    }
  };

  const [openModal, closeModal] = createDialogActionHandlers<
    SaleUrlDialog,
    SaleUrlQueryParams
  >(navigate, params => saleUrl(id, params), params);

  const handleCatalogueAdd = (data: SaleCataloguesAdd) => {
    if (data.saleCataloguesAdd.errors.length === 0) {
      closeModal();
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Sales Successfully Updated."
        })
      });
      refetchVariant();
      // if (data.saleCataloguesAdd.sale.type === SaleType.PERCENTAGE) {
      //   refetchProduct();
      // } else {
      //   refetchVariant();
      // }
    } else {
      notify({
        status: "error",
        text: data.saleCataloguesAdd.errors[0].message
      });
    }
  };

  const handleCatalogueRemove = (data: SaleCataloguesRemove) => {
    if (data.saleCataloguesRemove.errors.length === 0) {
      closeModal();
      reset();
      notify({
        status: "success",
        text: intl.formatMessage({
          defaultMessage: "Sales Successfully Updated."
        })
      });
      refetchVariant();
      // if (data.saleCataloguesRemove.sale.type === SaleType.PERCENTAGE) {
      //   refetchProduct();
      // } else {
      //   refetchVariant();
      // }
    } else {
      notify({
        status: "error",
        text: data.saleCataloguesRemove.errors[0].message
      });
    }
  };

  useEffect(() => {
    if (!!brand.value && params.brand !== brand.value) {
      navigate(saleListUrl({ brand: brand.value }));
    }
  }, [brand.value]);

  const canOpenBulkActionDialog = maybe(() => params.ids.length > 0);
  return (
    <TypedSaleCataloguesRemove onCompleted={handleCatalogueRemove}>
      {(saleCataloguesRemove, saleCataloguesRemoveOpts) => (
        <TypedSaleCataloguesAdd onCompleted={handleCatalogueAdd}>
          {(saleCataloguesAdd, saleCataloguesAddOpts) => (
            <TypedSaleUpdate onCompleted={handleSaleUpdate}>
              {(saleUpdate, saleUpdateOpts) => (
                <TypedUpdateSaleStatus onCompleted={handleUpdateSaleStatus}>
                  {(updateSaleStatus, updateSaleStatusOpts) => {
                    const storesAssign = data?.sale?.tenants.edges.map(
                      edge => edge.node
                    );
                    const tabPageInfo =
                      params.activeTab === SaleDetailsPageTab.categories
                        ? maybe(() => data.sale.categories.pageInfo)
                        : params.activeTab === SaleDetailsPageTab.collections
                        ? maybe(() => data.sale.collections.pageInfo)
                        : // : data &&
                          //   data.sale &&
                          //   data.sale.type === "ABSOLUTE_VALUE"
                          maybe(
                            () => variantData.sale.productVariants.pageInfo
                          );
                    // : maybe(() => productData.sale.products.pageInfo);

                    const handleCategoriesUnassign = (ids: string[]) =>
                      saleCataloguesRemove({
                        variables: {
                          ...paginationState,
                          id,
                          input: {
                            categories: ids
                          }
                        }
                      });

                    const handleCollectionsUnassign = (ids: string[]) =>
                      saleCataloguesRemove({
                        variables: {
                          ...paginationState,
                          id,
                          input: {
                            collections: ids
                          }
                        }
                      });

                    const handleProductsUnassign = (ids: string[]) => {
                      // const input = { product_variants: [], products: [] };
                      // if (data.sale.type === SaleType.PERCENTAGE) {
                      //   input.products = ids;
                      // } else {
                      //   input.product_variants = ids;
                      // }
                      setSaleSubsidyErrorQuantity(null);
                      refetchErrorVariantCount();
                      const createParams = ids.map(id => ({
                        product_variant: id
                      }));
                      saleCataloguesRemove({
                        variables: {
                          id,
                          input: {
                            productVariants: createParams
                            // ...input
                          }
                        }
                      });
                    };

                    const handleSubmit = async (
                      data: SaleDetailsPageFormData
                    ) => {
                      const result = await saleUpdate({
                        variables: {
                          id,
                          input: {
                            description: data.description,
                            endDate: changeTimeZone(data.endDate, data.endTime),
                            isAppliedToAllMalls: false,
                            isAppliedToAllStores: data?.isAppliedToAllStores,
                            name: data.name,
                            startDate: changeTimeZone(
                              data.startDate,
                              data.startTime
                            ),
                            type: discountValueTypeEnum(data.type),
                            value: decimal(data.value)
                          }
                        }
                      });

                      return result.data.saleUpdate.errors;
                    };

                    const {
                      loadNextPage,
                      loadPreviousPage,
                      pageInfo
                    } = paginate(tabPageInfo, paginationState, params);

                    return (
                      <>
                        <WindowTitle
                          title={intl.formatMessage(sectionNames.sales)}
                        />
                        <SaleDetailsPage
                          isKAMS={saleUser.isKAMS}
                          brand={brand.value}
                          kamsBrands={brandChoices}
                          brandLabel={brand.label}
                          onBrandChange={onBrandChange}
                          defaultCurrency={maybe(() => shop.defaultCurrency)}
                          sale={maybe(() => data.sale)}
                          disabled={loading || saleCataloguesRemoveOpts.loading}
                          errors={saleUpdateOpts.data?.saleUpdate.errors || []}
                          // products={maybe(() => productData.sale.products)}
                          products={undefined}
                          saleSubsidyErrorQuantity={saleSubsidyErrorQuantity}
                          saleErrorExportFileLink={saleErrorExportFileLink}
                          variants={maybe(
                            () => variantData.sale.productVariants
                          )}
                          pageInfo={pageInfo}
                          onNextPage={loadNextPage}
                          onPreviousPage={loadPreviousPage}
                          onStoreAssign={() => openModal("assign-store")}
                          onStoreUnassign={stores =>
                            saleUpdate({
                              variables: {
                                ...paginationState,
                                id,
                                input: {
                                  endDate: data.sale?.endDate,
                                  isAppliedToAllMalls: false,
                                  isAppliedToAllStores:
                                    storesAssign
                                      .filter(tenant => tenant.id !== stores)
                                      .map(tenant => tenant.id).length === 0
                                      ? true
                                      : false,
                                  startDate: data.sale?.startDate,
                                  tenants: storesAssign
                                    .filter(tenant => tenant.id !== stores)
                                    .map(tenant => tenant.id)
                                }
                              }
                            })
                          }
                          // onProductAssign={() => openModal("assign-product")}
                          onProductAssign={() =>
                            navigate(saleUrl(id, { action: "assign-product" }))
                          }
                          onProductUnassign={productId =>
                            handleProductsUnassign([productId])
                          }
                          onProductClick={id => () => navigate(productUrl(id))}
                          activeTab={params.activeTab}
                          onBack={() => navigate(saleListUrl())}
                          onTabClick={changeTab}
                          onSubmit={handleSubmit}
                          onRemove={() => openModal("remove")}
                          saveButtonBarState={saleUpdateOpts.status}
                          productListToolbar={
                            <Button
                              color="primary"
                              onClick={() =>
                                openModal("unassign-product", {
                                  ids: listElements
                                })
                              }
                            >
                              <FormattedMessage
                                defaultMessage="Unassign"
                                description="unassign product from sale, button"
                                id="saleDetailsUnassignProduct"
                              />
                            </Button>
                          }
                          isChecked={isSelected}
                          selected={listElements.length}
                          toggle={toggle}
                          toggleAll={toggleAll}
                        />
                        <AssignDiscountSaleProductDialog
                          confirmButtonState={saleCataloguesAddOpts.status}
                          hasMore={
                            searchProductsOpts?.data?.search?.pageInfo
                              ?.hasNextPage
                          }
                          open={params.action === "assign-product"}
                          onFetch={searchProducts}
                          onFetchMore={loadMoreProducts}
                          loading={searchProductsOpts.loading}
                          onClose={closeModal}
                          categories={categories}
                          fetchCategories={searchCategories}
                          fetchMoreCategories={{
                            hasMore: maybe(
                              () =>
                                searchCategoriesOpts.data.search.pageInfo
                                  .hasNextPage
                            ),
                            loading: searchCategoriesOpts.loading,
                            onFetchMore: loadMoreCategories
                          }}
                          selectCategory={value => setSelectedCategory(value)}
                          onSubmit={products =>
                            saleCataloguesAdd({
                              variables: {
                                id,
                                input: {
                                  products: products.map(product => product.id)
                                }
                              }
                            })
                          }
                          products={maybe(() =>
                            searchProductsOpts.data.search.edges
                              .map(edge => edge.node)
                              .filter(suggestedProduct => suggestedProduct.id)
                          )}
                        />
                        {params.action === "assign-product" && (
                          <AssignProductSubsidyDialog
                            brands={sellerBrandChoices}
                            fetchBrands={query => searchBrands(query)}
                            fetchMoreBrands={{
                              hasMore: maybe(
                                () =>
                                  brandsQueryData &&
                                  brandsQueryData.data &&
                                  brandsQueryData.data.search.pageInfo
                                    .hasNextPage
                              ),
                              loading: brandsQueryData.loading,
                              onFetchMore: loadMoreBrand
                            }}
                            confirmButtonState={saleCataloguesAddOpts.status}
                            hasMore={
                              searchProductsOpts.data?.search.pageInfo
                                .hasNextPage
                            }
                            categories={categories}
                            fetchCategories={searchCategories}
                            fetchMoreCategories={{
                              hasMore: maybe(
                                () =>
                                  searchCategoriesOpts.data.search.pageInfo
                                    .hasNextPage
                              ),
                              loading: searchCategoriesOpts.loading,
                              onFetchMore: loadMoreCategories
                            }}
                            selectCategory={value => setSelectedCategory(value)}
                            open={params.action === "assign-product"}
                            onFetch={searchProducts}
                            onFetchMore={loadMoreProducts}
                            // onSelectBrand={value =>
                            //   setCurrentBrand(value)
                            // }
                            onSelectBrand={brand => setSelectedBrand(brand)}
                            loading={searchProductsOpts.loading}
                            // onClose={closeModal}
                            onClose={() => {
                              setSelectedCategory(null);
                              navigate(saleUrl(id));
                            }}
                            onSubmit={products => {
                              saleCataloguesAdd({
                                variables: {
                                  ...paginationState,
                                  id,
                                  input: products
                                }
                              });
                              setSaleSubsidyErrorQuantity(null);
                              refetchErrorVariantCount();
                            }}
                            // onSubmit={() => undefined}
                            products={maybe(() =>
                              searchProductsOpts.data.search.edges
                                .map(edge => edge.node)
                                .filter(suggestedProduct => suggestedProduct.id)
                            )}
                            type={maybe(() =>
                              discountValueTypeEnum(data.sale.type)
                            )}
                            variants={maybe(
                              () => variantData.sale.productVariants
                            )}
                            onFetchMoreVariants={loadNextPage}
                          />
                        )}
                        <AssignStoresDialog
                          confirmButtonState={saleUpdateOpts.status}
                          stores={maybe(() =>
                            searchStoresOpts.data.search.edges
                              .map(edge => edge.node)
                              .filter(suggestedStore => suggestedStore.id)
                          )}
                          onClose={() => navigate(saleUrl(id))}
                          onConfirm={formData =>
                            saleUpdate({
                              variables: {
                                ...paginationState,
                                id,
                                input: {
                                  endDate: data.sale?.endDate,
                                  isAppliedToAllMalls: false,
                                  isAppliedToAllStores:
                                    formData?.stores?.length !== 0
                                      ? false
                                      : true,
                                  startDate: data.sale?.startDate,
                                  tenants: formData.stores
                                }
                              }
                            })
                          }
                          onFetch={searchStore}
                          open={params.action === "assign-store"}
                          initial={maybe(() => data?.sale?.tenants?.edges)}
                        />
                        <ActionDialog
                          open={
                            params.action === "unassign-category" &&
                            canOpenBulkActionDialog
                          }
                          title={intl.formatMessage({
                            defaultMessage: "Unassign Categories From Sale",
                            description: "dialog header"
                          })}
                          confirmButtonState={saleCataloguesRemoveOpts.status}
                          onClose={closeModal}
                          onConfirm={() => handleCategoriesUnassign(params.ids)}
                        >
                          {canOpenBulkActionDialog && (
                            <DialogContentText>
                              <FormattedMessage
                                defaultMessage="{counter,plural,one{Are you sure you want to unassign this category?} other{Are you sure you want to unassign {displayQuantity} categories?}}"
                                description="dialog content"
                                values={{
                                  counter: params.ids.length,
                                  displayQuantity: (
                                    <strong>{params.ids.length}</strong>
                                  )
                                }}
                              />
                            </DialogContentText>
                          )}
                        </ActionDialog>
                        <ActionDialog
                          open={
                            params.action === "unassign-collection" &&
                            canOpenBulkActionDialog
                          }
                          title={intl.formatMessage({
                            defaultMessage: "Unassign Collections From Sale",
                            description: "dialog header"
                          })}
                          confirmButtonState={saleCataloguesRemoveOpts.status}
                          onClose={closeModal}
                          onConfirm={() =>
                            handleCollectionsUnassign(params.ids)
                          }
                        >
                          {canOpenBulkActionDialog && (
                            <DialogContentText>
                              <FormattedMessage
                                defaultMessage="{counter,plural,one{Are you sure you want to unassign this collection?} other{Are you sure you want to unassign {displayQuantity} collections?}}"
                                description="dialog content"
                                values={{
                                  counter: params.ids.length,
                                  displayQuantity: (
                                    <strong>{params.ids.length}</strong>
                                  )
                                }}
                              />
                            </DialogContentText>
                          )}
                        </ActionDialog>
                        <ActionDialog
                          open={
                            params.action === "unassign-product" &&
                            canOpenBulkActionDialog
                          }
                          title={intl.formatMessage({
                            defaultMessage: "Unassign Products From Sale",
                            description: "dialog header"
                          })}
                          confirmButtonState={saleCataloguesRemoveOpts.status}
                          onClose={closeModal}
                          onConfirm={() => handleProductsUnassign(params.ids)}
                        >
                          {canOpenBulkActionDialog && (
                            <DialogContentText>
                              <FormattedMessage
                                defaultMessage="{counter,plural,one{Are you sure you want to unassign this product?} other{Are you sure you want to unassign {displayQuantity} products?}}"
                                description="dialog content"
                                values={{
                                  counter: params.ids.length,
                                  displayQuantity: (
                                    <strong>{params.ids.length}</strong>
                                  )
                                }}
                              />
                            </DialogContentText>
                          )}
                        </ActionDialog>
                        <ActionDialog
                          open={params.action === "remove"}
                          title={intl.formatMessage({
                            defaultMessage: "Deactivate Sale",
                            description: "dialog header"
                          })}
                          confirmButtonState={updateSaleStatusOpts.status}
                          onClose={closeModal}
                          variant="delete"
                          confirmButtonLabel="Deactivate"
                          onConfirm={() =>
                            updateSaleStatus({
                              variables: {
                                id,
                                status: DiscountStatusEnum.INACTIVE
                              }
                            })
                          }
                        >
                          <DialogContentText>
                            <FormattedMessage
                              defaultMessage="Are you sure you want to deactivate {saleName}?"
                              description="dialog content"
                              values={{
                                saleName: (
                                  <strong>
                                    {maybe(() => data.sale.name, "...")}
                                  </strong>
                                )
                              }}
                            />
                          </DialogContentText>
                        </ActionDialog>
                      </>
                    );
                  }}
                </TypedUpdateSaleStatus>
              )}
            </TypedSaleUpdate>
          )}
        </TypedSaleCataloguesAdd>
      )}
    </TypedSaleCataloguesRemove>
  );
};
export default SaleDetails;
